import { SpecialistServicePath } from "utils/constants";
import { buildQueryString } from "utils/helpers";

export const specialistRequests = {
  postSpecialistsApplicationCorrectionFields: ({ campaignId, id }) =>
    `${SpecialistServicePath}campaigns/${campaignId}/applications/${id}/return-for-correction`,

  enrollSpecialists: () => `${SpecialistServicePath}specialists/enroll`,

  patchSupervisorForSpecialist: specialistId => `${SpecialistServicePath}specialists/${specialistId}/supervisor`,

  postCurriculaPrerequisites: curriculumId => `${SpecialistServicePath}curricula/${curriculumId}/prerequisites`,

  getCurriculaPrerequisites: curriculumId => `${SpecialistServicePath}curricula/${curriculumId}/prerequisites`,

  deleteCurriculaPrerequisite: (curriculumId, itemId, prerequisiteItemId) =>
    `${SpecialistServicePath}curricula/${curriculumId}/items/${itemId}/prerequisites/${prerequisiteItemId}`,

  getSpecialistRankingsByCampaignId: (
    campaignId,
    { isAccepted, priority, specializationId, trainingBuildingId } = {},
  ) =>
    `${SpecialistServicePath}campaigns/${campaignId}/rankings${buildQueryString({
      IsAccepted: isAccepted,
      Priority: priority,
      SpecializationId: specializationId,
      TrainingBuildingId: trainingBuildingId,
    })}`,

  addTrainingBuildingSpecializations: buildingId =>
    `${SpecialistServicePath}training-buildings/${buildingId}/specializations`,

  updateTrainingBuildingAccreditationExpireDate: (buildingId, specializationId) =>
    `${SpecialistServicePath}training-buildings/${buildingId}/specializations/${specializationId}/accreditation`,

  getCampaignApplicationById: (campaignId, applicationId) =>
    `${SpecialistServicePath}campaigns/${campaignId}/applications/${applicationId}`,

  getSpecialistsCurriculumItems: specialistId => `${SpecialistServicePath}specialists/${specialistId}/curriculum-items`,

  updateSpecialistCurriculumItemCompletions: (specialistId, curriculumItemId) =>
    `${SpecialistServicePath}specialists/${specialistId}/curriculum-items/${curriculumItemId}/completions`,

  updateSpecialistCurriculumItemEstimations: specialistId =>
    `${SpecialistServicePath}specialists/${specialistId}/curriculum-items/estimations`,

  changeSpecialistStatus: specialistId => `${SpecialistServicePath}specialists/${specialistId}/status`,

  getExamCommitteeById: examCommitteeId => `${SpecialistServicePath}exam-committees/${examCommitteeId}`,

  // Curricula — modules / items / courses
  addCurriculumModules: curriculumId => `${SpecialistServicePath}curricula/${curriculumId}/modules`,
  updateCurriculumModule: (curriculumId, moduleId) =>
    `${SpecialistServicePath}curricula/${curriculumId}/modules/${moduleId}`,
  addCurriculumItems: curriculumId => `${SpecialistServicePath}curricula/${curriculumId}/items`,
  updateCurriculumItem: (curriculumId, itemId) => `${SpecialistServicePath}curricula/${curriculumId}/items/${itemId}`,
  addCurriculumCourses: curriculumId => `${SpecialistServicePath}curricula/${curriculumId}/courses`,
  deleteCurriculumCourse: (curriculumId, definitionId) =>
    `${SpecialistServicePath}curricula/${curriculumId}/courses/${definitionId}`,
  deleteCurriculumEntity: (curriculumId, type, id) => `${SpecialistServicePath}curricula/${curriculumId}/${type}/${id}`,

  // Specialization fees
  getSpecializationFees: specializationId => `${SpecialistServicePath}specializations/${specializationId}/fees`,
  updateSpecializationFees: specializationId => `${SpecialistServicePath}specializations/${specializationId}/fees`,
  getSpecializationFeesHistory: specializationId =>
    `${SpecialistServicePath}specializations/${specializationId}/fees/history`,
  getSpecializationExamsIds: () => `${SpecialistServicePath}specializations/exams/ids`,

  // Exam committee — status / members / contact
  updateExamCommitteeStatus: (examCommitteeId, action) =>
    `${SpecialistServicePath}exam-committees/${examCommitteeId}/${action}`,
  addExamCommitteeMembers: examCommitteeId => `${SpecialistServicePath}exam-committees/${examCommitteeId}/members`,
  updateExamCommitteeMember: (examCommitteeId, memberId) =>
    `${SpecialistServicePath}exam-committees/${examCommitteeId}/members/${memberId}`,
  deleteExamCommitteeMember: (examCommitteeId, memberId) =>
    `${SpecialistServicePath}exam-committees/${examCommitteeId}/members/${memberId}`,
  updateExamCommitteeContact: examCommitteeId => `${SpecialistServicePath}exam-committees/${examCommitteeId}/contact`,

  // Campaign exams — grades & results
  getCampaignExamApplications: (campaignId, examId) =>
    `${SpecialistServicePath}campaigns/${campaignId}/exams/${examId}/applications`,
  postCampaignExamResults: (campaignId, examId) =>
    `${SpecialistServicePath}campaigns/${campaignId}/exams/${examId}/results`,
  patchCampaignExamApplicationResult: (campaignId, examId, applicationId) =>
    `${SpecialistServicePath}campaigns/${campaignId}/exams/${examId}/results/${applicationId}`,

  // Campaign applications
  updateCampaignApplicationStatus: (campaignId, applicationId) =>
    `${SpecialistServicePath}campaigns/${campaignId}/applications/${applicationId}/status`,
  patchCampaignApplicationDiplomaGrade: (campaignId, applicationId) =>
    `${SpecialistServicePath}campaigns/${campaignId}/applications/${applicationId}/diploma-grade`,

  // Healthcare
  getHealthcareCampaigns: () => `${SpecialistServicePath}healthcare-campaigns`,
  getHealthcareCampaignApplicationById: (campaignId, applicationId) =>
    `${SpecialistServicePath}healthcare-campaigns/${campaignId}/applications/${applicationId}`,
  postHealthcareCampaignApplication: campaignId => `${SpecialistServicePath}healthcare-campaigns/${campaignId}/applications`,
  updateHealthcareCampaignApplicationStatus: (campaignId, applicationId) =>
    `${SpecialistServicePath}healthcare-campaigns/${campaignId}/applications/${applicationId}/status`,

  getHealthcareCoursesFeeDistributions: () => `${SpecialistServicePath}healthcare-courses-fee-distributions`,
  postHealthcareCourseFeeDistribution: () => `${SpecialistServicePath}healthcare-courses/fee-distributions`,
  getHealthcareCourseFeeDistributionHistory: () =>
    `${SpecialistServicePath}healthcare-courses/fee-distributions/history`,

  getHealthcareCourseDailyPrices: year => `${SpecialistServicePath}healthcare-course-daily-prices/${year}`,
  updateHealthcareCourseDailyPrices: year => `${SpecialistServicePath}healthcare-course-daily-prices/${year}`,

  getHealthcareCoursesByYear: year => `${SpecialistServicePath}healthcare-courses/by-year/${year}`,

  // Postgraduate courses
  getPostgraduateCoursesYearFinalization: year =>
    `${SpecialistServicePath}postgraduate-courses/years/${year}/finalization`,
  finalizePostgraduateCoursesYear: year => `${SpecialistServicePath}postgraduate-courses/years/${year}/finalization`,

  // Advanced specializations
  updateAdvancedSpecializationProfessors: advancedSpecializationId =>
    `${SpecialistServicePath}advanced-specializations/${advancedSpecializationId}/professors`,
  updateAdvancedSpecializationFees: advancedSpecializationId =>
    `${SpecialistServicePath}advanced-specializations/${advancedSpecializationId}/fees`,
  updateAdvancedSpecializationExaminationHeads: advancedSpecializationId =>
    `${SpecialistServicePath}advanced-specializations/${advancedSpecializationId}/examination-heads`,

  // Advanced specialization specialists — periods
  addAdvancedSpecializationSpecialistPeriods: specialistId =>
    `${SpecialistServicePath}advanced-specialization-specialists/${specialistId}/periods`,
  markAdvancedSpecializationSpecialistPeriodPaid: (specialistId, periodId) =>
    `${SpecialistServicePath}advanced-specialization-specialists/${specialistId}/periods/${periodId}/paid`,
  generateAdvancedSpecializationSpecialistPeriodReferral: (specialistId, periodId) =>
    `${SpecialistServicePath}advanced-specialization-specialists/${specialistId}/periods/${periodId}/referral`,
  addAdvancedSpecializationSpecialistAdditionalTrainings: specialistId =>
    `${SpecialistServicePath}advanced-specialization-specialists/${specialistId}/additional-trainings`,
  addAdvancedSpecializationSpecialistFinalExamProtocol: specialistId =>
    `${SpecialistServicePath}advanced-specialization-specialists/${specialistId}/final-exam-protocols`,

  //Selects
  getSpecialistCampaignsSelect: () => `${SpecialistServicePath}campaigns/select`,

  getSpecialistCurriculaSelect: () => `${SpecialistServicePath}curricula/select`,

  getSpecialistReceptionTypesSelect: specializationId =>
    `${SpecialistServicePath}specializations/${specializationId}/reception-types/select`,

  getSpecializationsSelect: () => `${SpecialistServicePath}specializations/select`,

  getTrainingBuildingsSelect: () => `${SpecialistServicePath}training-buildings/select`,

  getSpecializationLaborCategoriesSelect: () => `${SpecialistServicePath}selects/SpecializationLaborCategory`,

  getSpecializationTypesSelect: () => `${SpecialistServicePath}selects/SpecializationType`,

  getHealthcareSpecialitySelect: () => `${SpecialistServicePath}selects/HealthcareSpeciality`,

  getAdvancedSpecializationsSelect: () => `${SpecialistServicePath}advanced-specializations/select`,
  getPostgraduateCourseTypesSelect: () => `${SpecialistServicePath}postgraduate-course/types/select`,

  getPostgraduateCourseDefinitionsSelect: () => `${SpecialistServicePath}postgraduate-course/definitions/select`,

  getCampaignApplicationStatusesSelect: () => `${SpecialistServicePath}campaigns/applications/statuses/select`,

  getHealthcareCampaignApplicationStatusesSelect: () =>
    `${SpecialistServicePath}healthcare-campaigns/applications/statuses/select`,

  getProfessorsByAdvancedSpecializationSelect: specializationId =>
    `${SpecialistServicePath}advanced-specializations/${specializationId}/professors/select`,

  getAdvancedSpecializationsBuildingsSelect: specializationId =>
    `${SpecialistServicePath}advanced-specializations/${specializationId}/buildings/select`,
};
